import React, { useState, useEffect } from 'react';
// Import images
import galleryImg1 from '../img/envision/about/aboutone.jpg';
import galleryImg2 from '../img/envision/about/banner-3-blog-it-trends.jpg';
import galleryImgs31 from '../img/envision/dropdown/new/cmd.jpg';
import galleryImg41 from '../img/envision/dropdown/new/cmd.jpg';

const galleryImages = [galleryImg1, galleryImg2];
const galleryImagess = [galleryImgs31, galleryImg41];

const AboutEnvisonSection = () => {
    const [currentImage, setCurrentImage] = useState(galleryImages[0]);
    const [currentImages, setCurrentImages] = useState(galleryImagess[0]);

    // Function to cycle through images in galleryImages (first gallery)
    const changeFirstImage = () => {
        setCurrentImage((prevImage) => {
            const currentIndex = galleryImages.indexOf(prevImage);
            return galleryImages[(currentIndex + 1) % galleryImages.length];
        });
    };

    // Function to cycle through images in galleryImagess (second gallery)
    const changeSecondImage = () => {
        setCurrentImages((prevImage) => {
            const currentIndex = galleryImagess.indexOf(prevImage);
            return galleryImagess[(currentIndex + 1) % galleryImagess.length];
        });
    };

    // useEffect for cycling through galleryImages (first image set)
    useEffect(() => {
        const intervalId = setInterval(changeFirstImage, 3000); // Change image every 3 seconds
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    // useEffect for cycling through galleryImagess (second image set)
    useEffect(() => {
        const intervalId = setInterval(changeSecondImage, 4000); // Change image every 4 seconds
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    return (
        <section style={{ marginTop: '-80px' }}>
            <div className="container">
                <div className="row">
                    <div className="col-md-6" style={{ marginTop: '100px' }}>
                        <img
                            src={currentImage} // First gallery image
                            alt="gallery1"
                            className="imgbg-col"
                            style={{ maxWidth: '100%', padding: '15px', height: '85%' }}
                        />
                    </div>

                    <div className="col-md-6" style={{ marginTop: '100px' }}>
                        <div className="detailcontent">
                            <div
                                className="subheading title-datas"
                                style={{
                                    color: 'rgb(28, 29, 29)',
                                    fontSize: '28px',
                                    marginBottom: '41px',
                                    textAlign: 'center',
                                }}
                            >
                                Our <span style={{ color: 'rgb(11 130 153)' }}>Promise</span>
                            </div>
                            <div className="textdetail">
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                    Envision (Estd: 1991, NSE: Envision) partners with over 300 customers,
                                    including 40% of the top 100 global innovators, to deliver intelligent
                                    engineering and technology solutions for creating a digital, autonomous,
                                    and sustainable future. As a company, Envision is committed to designing
                                    a culturally inclusive, socially responsible, and environmentally sustainable
                                    Tomorrow Together with our stakeholders.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                
            </div>
        </section>
    );
};

export default AboutEnvisonSection;
